import { GetMonthNameByNumber } from "../../Helper/GetMonthNameByNumber";

export const formatFecha = (fecha) => {
    const dia = fecha.getDate().toString().padStart(2, 0);
    const mes = fecha.getMonth() + 1;
    const año = fecha.getFullYear();
  
    return `${GetMonthNameByNumber(mes)} ${año}`;
  };